'use strict';

/**
 * View for empty contact lists
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/community/templates/partials/conversation-post-empty.hbs');

var EmptyView = ItemView.extend({
    template: template,

    tagName: 'li',

    className: 'post empty-hint',
});

module.exports = EmptyView;